import { usePageHeader } from "Shared/Layouts/PageHeaderContext";

const DEV_PLACEHOLDER = "TODO: Dashboard UI";

export const DashboardPage = () => {
	usePageHeader({ title: "Dashboard" });

	return (
		<div className="text-muted-foreground flex h-full items-center justify-center text-sm">
			{DEV_PLACEHOLDER}
		</div>
	);
};
